var React = require('react');

function IcMoonSolidInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M15.7931 11.2276C15.9882 10.9147 15.6538 10.5586 15.3005 10.6645C14.5719 10.8828 13.7997 11.0001 13 11.0001C8.58172 11.0001 5 7.41843 5 3.00015C5 2.20049 5.11733 1.42824 5.3357 0.699667C5.4416 0.34635 5.08549 0.0118961 4.77252 0.207078C2.50732 1.61975 1 4.13392 1 7.00014C1 11.4184 4.58172 15.0001 9 15.0001C11.8662 15.0001 14.3804 13.4928 15.7931 11.2276Z","fill":"#000000"}));
}

IcMoonSolidInline.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = IcMoonSolidInline;

IcMoonSolidInline.default = IcMoonSolidInline;
